import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalModule } from 'src/app/modal/modal.module';
import { SharedModule } from '../../../shared/shared.module';
import { LoadingSpaceDescriptionComponent } from './loading-space-description/loading-space-description.component';
import { LoadingSpacePanelComponent } from './loading-space-panel.component';
import { LoadingSpaceSummaryComponent } from './loading-space-summary/loading-space-summary.component';

@NgModule({
  declarations: [
    LoadingSpacePanelComponent,
    LoadingSpaceDescriptionComponent,
    LoadingSpaceSummaryComponent,
  ],
  imports: [CommonModule, SharedModule, ModalModule],
  exports: [LoadingSpacePanelComponent, LoadingSpaceDescriptionComponent, LoadingSpaceSummaryComponent],
})
export class LoadingSpacePanelModule {}
